/**
 * Recieves key data from URL to resize it with expected dimensions
 * and return image using resizing service.
 * @param bucket => Image bucket
 * @param key => Image key
 * @param width => Expected width
 * @param height => Expected height
 * @param fit => Way to show thumbnail
 * @returns Url resized
 */
export function resizeUrl({ bucket, key, width = 250, height = 180, fit = 'contain' }: {
  bucket: string;
  key: string;
  width?: number,
  height?: number,
  fit?: 'contain' | 'cover',
}) {
  if (!bucket) return null;

  const base64 = window.btoa(JSON.stringify({
    bucket,
    key,
    width,
    height,
    fit,
    background: '#151515',
  }));

  return `${process.env.VUE_APP_RESIZE_URI}${base64}`;
}

export default resizeUrl;
